<div class="modal-container">
  <button
    id="modalEmail"
    #modalEmail
    data-bs-toggle="modal"
    data-bs-target="#modalE"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalE"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">Ingrese los datos</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="emailFG" (ngSubmit)="submitForm()">
            <div class="row">
              <div
                *ngFor="let field of emailForm"
                class="col-md-{{ field.width }}">
                <div class="mb-3">
                  <label
                    *ngIf="field.visible"
                    [for]="field.name"
                    class="form-label"
                    >{{ field.label
                    }}<span
                      *ngIf="field.required"
                      _ngcontent-ng-c3465959523=""
                      class="text-danger">
                      *</span
                    ></label
                  >
                  <!-- Text Input -->
                  <input
                    *ngIf="field.type === 'text'"
                    [id]="field.name"
                    [type]="field.type"
                    class="form-control"
                    [formControlName]="field.name" />
                  <!-- Validation Error Messages -->
                  <div *ngIf="getErrorMessage(field.name)" class="text-danger">
                    {{ getErrorMessage(field.name) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 d-flex gap-2">
              <button type="submit" class="btn-govco fill-btn-govco">
                Guardar
              </button>
              <button
                type="button"
                class="btn-govco btn-govco"
                data-bs-dismiss="modal">
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
